
export const LOCKED_AGENCIES = [
  { key: "TFDA", name: "衛福部食藥署", sourceUrl: "https://www.fda.gov.tw", notes: "食品安全、查驗登記、標示規範" },
  { key: "OSHA", name: "勞動部職安署", sourceUrl: "https://www.osha.gov.tw", notes: "職業安全衛生、勞檢裁罰" },
  { key: "MOENV", name: "環境部", sourceUrl: "https://www.moenv.gov.tw", notes: "環保回收、廢棄物處理" },
  { key: "PDPC", name: "個資籌備處", sourceUrl: "https://www.ndc.gov.tw", notes: "個人資料保護、資安通報" },
  { key: "CUSTOMS", name: "財政部關務署", sourceUrl: "https://web.customs.gov.tw", notes: "進出口通關、稅則分類" }
];

export const RISK_SCORE_STANDARD = {
  formula: "(嚴重度 × 2 + 發生機率 + 影響範圍) × 5",
  levels: [
    { label: "低風險 (Low)", range: "0 ~ 39 分", color: "#10b981", badgeColor: "rgba(16, 185, 129, 0.2)" },
    { label: "中風險 (Medium)", range: "40 ~ 69 分", color: "#f59e0b", badgeColor: "rgba(245, 158, 11, 0.2)" },
    { label: "高風險 (High)", range: "70 ~ 100 分", color: "#ef4444", badgeColor: "rgba(239, 68, 68, 0.2)" }
  ]
};

export const SUPER_ADMINS = [
  "kc@lg.app",
  "lisa@lg.app",
  "irene@lg.app",
  "ad@lg.app",
  "king@lg.app",
  "ken@lg.app",
  "it@lg.app"
];

export function isSuperAdmin(userEmail?: string | null): boolean {
  if (!userEmail) return false;
  return SUPER_ADMINS.includes(userEmail.toLowerCase());
}

export function getAdminPermissionsText(): string {
  return "超級管理員可：新增/修改/刪除所有專案、強制執行送審、重置簽核流程、管理主管機關清單。";
}
